export default "__VITE_ASSET__C0QT5$if__"